
export class TournamentTableVO {
    public id: number = 0;
    public tableName: string;
    public tableWinner: string;
    public currentPlayers: number = 0;
    public spectators: number = 0;
}
